import React, { useRef, useState } from 'react'
import "../Modratores/Modratores.scss"
import { useQuery } from 'react-query';
import axios from 'axios';
import { Baseurl } from './../../../Api/Baseurl';
import { MdDelete } from "react-icons/md";
import { MdOutlineEditNote } from "react-icons/md";
import { MdCloseFullscreen } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { toast } from 'react-toastify';
import { ToastOptions } from '../../../helpers/ToastOptions';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { VscFileSubmodule } from 'react-icons/vsc';
import { Link } from 'react-router-dom';

export default function Modulemoderatores() {
    const [addform, setaddform] = useState(false)
    const [popup, setpopup] = useState(false)
    const [Moddata, setModdata] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [limit] = useState(10);
    const token = localStorage.getItem('medtoken');
    const animationRef = useRef();
    const animationInView = useInView(animationRef, { once: true });

    const handleaddmod = () => {
        setaddform(!addform)
    }

    // delete mod 
    async function moderatorDel(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "The Module Moderator will be removed",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#01677e",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (res) => {
            if (res.isConfirmed) {
                await axios.delete(`${Baseurl}/admin/moduleModerator/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }).then((res) => {
                    toast.success("Module Moderator deleted successfully", ToastOptions("success"));
                    refetch()
                }).catch((error) => {
                    const errorMessage = error.response?.data?.msg || "There is a technical fault, please try again.";
                    toast.error(errorMessage, ToastOptions("error"));
                })
            }
        })
    }
    // delete mod 
    const Validation = Yup.object({
        name: Yup.string().required("name is required"),
        email: Yup.string().email("Email is not valid").required("Email is required"),
        password: Yup.string().required("Password is required"),
        university: Yup.string().required("University is required"),
        phoneNumber: Yup.string()
    })

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            password: '',
            university: '',
            phoneNumber: ''
        }, validationSchema: Validation, onSubmit: moderatoradd
    })

    async function moderatoradd(values) {
        try {
            await axios.post(
                `${Baseurl}/admin/addModuleModerator`,
                {
                    name: values.name,
                    email: values.email,
                    password: values.password,
                    university: values.university,
                    phoneNumber: values.phoneNumber,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                }
            );
            toast.success("Module Moderator added successfully", ToastOptions("success"));
            formik.resetForm()
            refetch();
        } catch (error) {
            const errorMessage = error.response?.data?.msg || "There is a technical fault, please try again.";
            toast.error(errorMessage, ToastOptions("error"));
        }
    }




    // get all mod 
    const AllModerators = async () => {
        const params = new URLSearchParams({
            page: currentPage,
            limit: limit,
            ...(searchTerm && { search: searchTerm })
        });
        
        let modrators = await axios.get(`${Baseurl}/admin/moduleModerators?${params}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return modrators.data.payload
    }
    const { data: moderatorsData, refetch } = useQuery(["getAllModuleModerators", currentPage, searchTerm], AllModerators, {
        // onError: () => {
        //     navigate("/Login")
        // }
    })
    // get all mod

    // update profile
    const closeprofile = () => {
        setpopup(!popup)
    }

    const UpdateStudentProfile = async (values) => {
        const updateData = {
            name: values.name,
            email: values.email,
            university: values.university,
            phoneNumber: values.phoneNumber,
        };

        // Only include password if it's provided and not empty
        if (values.password && values.password.trim() !== '') {
            updateData.password = values.password;
        }

        await axios.put(`${Baseurl}/admin/moduleModerator/${Moddata.id}`, updateData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,

                }
            }
        ).then((res) => {
            toast.success("Module Moderator updated", ToastOptions("success"))
            refetch()
            setpopup(!popup)
        }).catch((err) => {
            const errorMessage = err.response?.data?.msg || "Module Moderator update failed";
            toast.error(errorMessage, ToastOptions("error"))
            setpopup(!popup)
        })
    }
    // cailng api


    // validation 
    const profileValidation = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string().email("must be valid email").required("email is required"),
        university: Yup.string().required("University is required"),
        phoneNumber: Yup.string(),
        password: Yup.string().max(9, "Password must be at least 9 characters"),
    });
    // validation

    // setupformik 
    const profileFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: Moddata?.name || "",
            email: Moddata?.email || "",
            university: Moddata?.university || "",
            phoneNumber: Moddata?.phoneNumber || "",
            password: "",
        }, validationSchema: profileValidation,
        onSubmit: UpdateStudentProfile,
    })
    // setupformik 
    const HandleEditProfile = async (id) => {
        try {
            // Get the moderator data from the current list instead of making a new API call
            const moderator = moderatorsData?.moduleModerators?.find(mod => mod.id === id);
            if (moderator) {
                setModdata(moderator);
                setpopup(true);
            } else {
                toast.error("Moderator not found", ToastOptions("error"));
            }
        } catch (error) {
            console.error(error);
            toast.error("There is a technical fault, please try again.", ToastOptions("error"));
        }
    };
    // end profile update

    // animation 
    const animationVariants = {
        hidden: { opacity: 0, height: 0 },
        visible: { opacity: 1, height: "max-content" },
        exit: { opacity: 0, height: 0 }
    };
    // animation 
    return <>
        <div className="add">
            <button onClick={handleaddmod}>
                {addform ? "Close Add Module Moderator" : "Add Module Moderator"}
            </button>
        </div>
        {addform &&
            <AnimatePresence>
                <motion.div layout className="addmoderator" variants={animationVariants} initial="hidden" animate="visible" exit="exit">
                    <div className="addbody">
                        <form onSubmit={formik.handleSubmit} className=" mx-auto flex justify-between items-center">
                            <div className="mb-5 modfield">
                                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
                                <input type="text" id="name" value={formik.values.name} onBlur={formik.handleBlur} onChange={formik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="Name" required />
                            </div>
                            <div className="mb-5 modfield">
                                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                                <input type="email" id="email" value={formik.values.email} onBlur={formik.handleBlur} onChange={formik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="email@medflix.com" required />
                            </div>
                            <div className="mb-5 modfield">
                                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                                <input type="password" value={formik.values.password} onBlur={formik.handleBlur} onChange={formik.handleChange} id="password" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="Password123" required />
                            </div>
                            <div className="mb-5 modfield">
                                <label htmlFor="university" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">University</label>
                                <input type="text" id="university" value={formik.values.university} onBlur={formik.handleBlur} onChange={formik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="University Name" required />
                            </div>
                            <div className="mb-5 modfield">
                                <label htmlFor="phoneNumber" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Phone Number</label>
                                <input type="text" id="phoneNumber" value={formik.values.phoneNumber} onBlur={formik.handleBlur} onChange={formik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="+1234567890" />
                            </div>

                            <button type="submit" className="text-white focus:ring-blue-300 font-medium px-5 py-2.5 text-center ">Add Module Moderator</button>
                        </form>

                    </div>
                </motion.div >
            </AnimatePresence>
        }
                   <div className="mb-4  w-full  mx-auto mt-5">
                 <div className="w-full flex justify-center items-center">
                     <div className="relative">
                         <input
                             type="text"
                             placeholder="Search by name, email, or phone..."
                             value={searchTerm}
                             onChange={(e) => {
                                 setSearchTerm(e.target.value);
                                 setCurrentPage(1);
                             }}
                             className="pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-[#01677e] focus:border-[#01677e] w-80"
                         />
                         <MdSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
                     </div>
                 </div>
             </div>
        <motion.div layout ref={animationRef} initial={{ opacity: 0 }} animate={animationInView && { opacity: 1 }} transition={{ duration: 0.5 }} className='main-Orders'>
            {/* Search and Pagination Controls */}
   

            <div className=" overflow-x-auto shadow-md sm:rounded-lg">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Id</th>
                            <th scope="col" className="px-6 py-3">Name</th>
                            <th scope="col" className="px-6 py-3">Email</th>
                            <th scope="col" className="px-6 py-3">University</th>
                            <th scope="col" className="px-6 py-3">Phone</th>
                            <th scope="col" className="px-6 py-3">Status</th>
                            <th scope="col" className="px-6 py-3">Modules</th>
                            <th scope="col" className="px-6 py-3">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {moderatorsData?.moduleModerators?.map((ele, index) => {
                            return (
                                <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{ele.id}</td>
                                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{ele.name}</td>
                                    <td className="px-6 py-4">{ele.email}</td>
                                    <td className="px-6 py-4">{ele.university}</td>
                                    <td className="px-6 py-4">{ele.phoneNumber || 'N/A'}</td>
                                    <td className="px-6 py-4">
                                        <span className={`px-2 py-1 text-xs rounded-full ${
                                            ele.status === 'true' || ele.status === true
                                                ? 'bg-green-100 text-green-800' 
                                                : 'bg-red-100 text-red-800'
                                        }`}>
                                            {ele.status === 'true' || ele.status === true ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 svg-del">
                                        <Link to={`/modulemoderatores/AssignedModules/${ele.id}`}>
                                        <VscFileSubmodule />
                                        </Link>
                                    </td>
                                    <td className="px-6 py-4 svg-del flex">
                                        <MdOutlineEditNote onClick={() => HandleEditProfile(ele.id)} />
                                        <MdDelete onClick={() => moderatorDel(ele.id)} />
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>

                {/* Pagination Controls */}
                {moderatorsData?.pagination && (
                    <div className="flex justify-between items-center mt-4 px-6 py-3">
                        <div className="flex space-x-2">
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={!moderatorsData.pagination.hasPrevPage}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                            >
                                Previous
                            </button>
                            <button
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, moderatorsData.pagination.totalPages))}
                                disabled={!moderatorsData.pagination.hasNextPage}
                                className="px-3 py-1 text-sm border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                            >
                                Next
                            </button>
                        </div>
                        <div className="text-sm text-gray-600">
                            Showing {((moderatorsData.pagination.currentPage - 1) * moderatorsData.pagination.limit) + 1} to {Math.min(moderatorsData.pagination.currentPage * moderatorsData.pagination.limit, moderatorsData.pagination.totalCount)} of {moderatorsData.pagination.totalCount} entries
                        </div>
                    </div>
                )}
                {popup && <div onClick={closeprofile} className="back-drop">
                </div>}
                <div className={popup ? "popup apperdetails" : "popup"}>
                    <MdCloseFullscreen className='closedetails' onClick={closeprofile} />
                    <div className="profile">
                        {/* <div className="img" style={{
                            backgroundImage: `url(${profile})`, backgroundSize: 'cover',
                            backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
                            width: '120px',
                            height: '120px'
                        }}>
                        </div> */}
                        <form onSubmit={profileFormik.handleSubmit} className=" mx-auto justify-between items-center">
                            <div className="mb-5 teachfield">
                                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
                                <input type="text" id="name" value={profileFormik.values.name} onBlur={profileFormik.handleBlur} onChange={profileFormik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="Name" required />
                            </div>
                            <div className="mb-5 teachfield">
                                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                                <input type="email" id="email" value={profileFormik.values.email} onBlur={profileFormik.handleBlur} onChange={profileFormik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="email@medflix.com" required />
                            </div>
                            <div className="mb-5 teachfield">
                                <label htmlFor="university" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">University</label>
                                <input type="text" id="university" value={profileFormik.values.university} onBlur={profileFormik.handleBlur} onChange={profileFormik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="University Name" required />
                            </div>
                            <div className="mb-5 teachfield">
                                <label htmlFor="phoneNumber" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Phone Number</label>
                                <input type="text" id="phoneNumber" value={profileFormik.values.phoneNumber} onBlur={profileFormik.handleBlur} onChange={profileFormik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="+1234567890" />
                            </div>
                            <div className="mb-5 teachfield">
                                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">New Password (Optional)</label>
                                <input type="password" id="password" value={profileFormik.values.password} onBlur={profileFormik.handleBlur} onChange={profileFormik.handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[#01677e] focus:border-[#01677e] block w-full p-2.5 " placeholder="Leave empty to keep current password" />
                                <p className="mt-1 text-xs text-gray-500">Leave empty to keep the current password unchanged</p>
                                {profileFormik.errors.password && profileFormik.touched.password ? (
                                    <p className="mt-1 text-sm text-red-600">{profileFormik.errors.password}</p>
                                ) : null}
                            </div>
                            <button type="submit" className="text-white focus:ring-blue-300 font-medium px-5 py-2.5 text-center ">Update Module Moderator</button>
                        </form>
                    </div>
                </div>
            </div>

        </motion.div>
    </>
}
